import { useEffect, useState } from 'react';
import styles from './AppendFilesModal.module.css';
import Modal from 'ui/Modal';
import { observer } from 'mobx-react-lite';
import { productionStore } from 'store/mobx/production.store';
import Select from 'ui/Select';
import searchIcon from 'assets/svg/serch-01.svg';
import FileIcon from 'assets/svg/icons/icon_file-01.svg';
import addIcon from 'assets/svg/add-green-01.svg';
import deleteIcon from 'assets/svg/delete-01.svg';
import IconButton from 'ui/IconButton';

export const AppendFilesModal = observer(
  ({ isOpen, onClose, onSubmit, node, selectedSourceFiles = [] }) => {
    const { selectedProduction } = productionStore;
    const [selectedFiles, setSelectedFiles] = useState(selectedSourceFiles);
    const [sourceFiles, setSourceFiles] = useState([
      {
        name: 'Название файла 1',
        created_at: '2025-07-09T12:09:25.292Z',
        url: 'projects/5/Invoice_09.06.2025 (8) (2) (1).xlsx',
      },
      {
        name: 'Название файла 2',
        created_at: '2025-07-09T12:09:25.292Z',
        url: 'projects/4/Invoice_09.06.2025 (8) (2) (1).xlsx',
      },
      {
        name: 'Название файла 3',
        created_at: '2025-07-09T12:09:25.292Z',
        url: 'projects/3/Invoice_09.06.2025 (8) (2) (1).xlsx',
      },
    ]);
    const [files, setFiles] = useState([]);
    const [selectedDevice, setSelectedDevice] = useState(
      selectedProduction?.[0].used_devices?.[0]?.id,
    );
    const [filter, setFilter] = useState({ search: '', sortBy: 'date' });

    useEffect(() => {
      setSelectedFiles(selectedSourceFiles);
    }, []);

    useEffect(() => {
      const urls = selectedFiles.map((item) => item.url);
      setFiles(sourceFiles.filter((item) => !urls.includes(item.url)));
    }, [selectedFiles]);

    const handleSubmit = () => {
      onSubmit(selectedFiles);
      onClose();
    };

    return (
      <Modal
        title="Выбор файлов"
        onClose={onClose}
        onSubmit={handleSubmit}
        open={isOpen}
        submitText="Сохранить"
      >
        <div className={styles.modalWrapper}>
          <div className={styles.device}>
            <span>Оборудование: </span>
            <Select
              options={selectedProduction?.[0].used_devices ?? []}
              value={selectedDevice}
              onChange={(value) => setSelectedDevice(value)}
              titleKey="name"
              clearable={false}
              valueKey="id"
              placeholder="Не выбрано"
            />
          </div>

          <div className={styles.sortItems}>
            <div className={styles.searchContainer}>
              <div className={styles.WorkLeftHeader_search}>
                <img className={styles.WorkLeftHeader_search_svg} src={searchIcon} alt={'search'} />
                <input
                  className={styles.WorkLeftHeader_search_input}
                  placeholder={'Поиск'}
                  value={filter.search}
                  onChange={(val) =>
                    setFilter((prevState) => ({ ...prevState, search: val.target.value }))
                  }
                />
              </div>
            </div>

            <div className={styles.sortByContainer}>
              <span>Сортировка по:</span>
              <Select
                options={[
                  { id: 'name', name: 'Название' },
                  { id: 'date', name: 'Дате создания' },
                ]}
                value={filter.sortBy}
                onChange={(value) => setFilter((prevState) => ({ ...prevState, sortBy: value }))}
                titleKey="name"
                valueKey="id"
                clearable={false}
                placeholder="Не выбрано"
              />
            </div>
          </div>

          <span className={styles.title}>Загруженные файлы: </span>

          <div className={styles.files}>
            {files.map((item, index) => (
              <div className={styles.file} key={index}>
                <div className={styles.fileContent}>
                  <img src={FileIcon} alt="logo-file" />
                  <span>{item.name}</span>
                </div>

                <IconButton
                  icon={addIcon}
                  size={20}
                  onClick={() => setSelectedFiles([...selectedFiles, item])}
                />
              </div>
            ))}
            {files.length === 0 && <div className={styles.emptyList}>Список пуст</div>}
          </div>

          <div className={styles.divide}></div>

          <span className={styles.title}>Выбранные файлы: </span>

          <div className={styles.files}>
            {selectedFiles.map((item, index) => (
              <div className={styles.file} key={index}>
                <div className={styles.fileContent}>
                  <img src={FileIcon} alt="logo-file" />
                  <span>{item.name}</span>
                </div>

                <IconButton
                  icon={deleteIcon}
                  size={20}
                  onClick={() =>
                    setSelectedFiles((prevState) =>
                      prevState.filter((file) => file.url !== item.url),
                    )
                  }
                />
              </div>
            ))}
            {selectedFiles.length === 0 && <div className={styles.emptyList}>Список пуст</div>}
          </div>
        </div>
      </Modal>
    );
  },
);

export default AppendFilesModal;
